import { defaultApiState } from "@/store/general.types";
import { DuplicateCitationState } from "./duplicate-citation.types";

export const duplicateCitationState: DuplicateCitationState = {
    getDuplicateCitation: defaultApiState,
    getPossibleDuplicateCitations: defaultApiState,
    markCitationAsDuplicate: defaultApiState,
    // JIRA: SUMDEV-2964
    markCitationAsManuallyMarkedDuplicate: defaultApiState,
    // JIRA: SUMDEV-2964
    markCitationAsNotDuplicate: defaultApiState,
    // JIRA: SUMDEV-2964
    replacePrimaryReferenceV2: defaultApiState,
    // JIRA: SUMDEV-2964
    replacePrimaryReferencePossibleV2: defaultApiState,
    // JIRA: SUMDEV-2964
    undoFileImportV2: defaultApiState,
    // JIRA: SUMDEV-2964
    getManuallyMarkedDuplicateCitationsV2: defaultApiState,
    updateCitationStatus: defaultApiState,
    duplicateCitationCount: defaultApiState,
    replacePrimaryReference: defaultApiState,
    getDuplicateCitationCountByFileId: defaultApiState,
    getManuallyMarkedDuplicateCitation: defaultApiState,
    getDuplicateCitationGroupCount: defaultApiState,
    getRemovedDuplicateUndoStackDetails: defaultApiState,
    getManuallyRemovedDuplicateUndoStackDetails: defaultApiState,
    getPartialDuplicateUndoStackDetails: defaultApiState,
    // JIRA: SUMDEV-2964
    getRemovedDuplicateUndoStackDetailsV2: defaultApiState,
    getManuallyRemovedDuplicateUndoStackDetailsV2: defaultApiState,
    revertCitationDuplicationStatuses: defaultApiState,
    // JIRA: SUMDEV-2964
    revertCitationDuplicationStatusesV2: defaultApiState,
    getScreeningCountByFile: defaultApiState,
    // JIRA: SUMDEV-2964
    getClusterBasedDuplicateCountsByFile: defaultApiState,
    // JIRA: SUMDEV-2964 - Possible duplicates undo
    getPossibleDuplicatesUndoStackDetailsV2: defaultApiState,
    revertPossibleDuplicatesRemovalV2: defaultApiState
}